import React from 'react';
import {Container} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import Carousel from 'react-bootstrap/Carousel';

import center1 from '../assets/images/center-banner1.png';
import center2 from '../assets/images/center-banner2.jpeg';
// import center3 from '../assets/images/center-banner3.jpg';
import center4 from '../assets/images/center-banner4.jpg';

//import bannerMob1 from '../assets/images/banners/mobile/1.jpg';
import bannerMob2 from '../assets/images/banners/mobile/2.jpg';
import bannerMob3 from '../assets/images/banners/mobile/3.jpg';
import bannerMob4 from '../assets/images/banners/mobile/4.jpg';





const Banner = props => {
  return (
    <>
      <section className='banner_sec'>
        <div className='banner_slider old desk_view'>
          <Carousel data-bs-theme="dark" id='carouselExampleAutoplaying'>
              {/* <Carousel.Item>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZXyQm_XnGGLZlQI9Ls-2CGYFokzMFINE82KajD5i-IKNeFw/viewform?embedded=true"
                   target="_blank">
                  <img
                    className="d-block w-100"
                    src={center3}
                    alt="first slide"
                  />     
                </a>          
              </Carousel.Item> */}
              <Carousel.Item>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZXyQm_XnGGLZlQI9Ls-2CGYFokzMFINE82KajD5i-IKNeFw/viewform?embedded=true" 
                target='_blank'>
                  <img
                    className="d-block w-100"
                    src={center4}
                    alt="second slide"
                  /> 
                </a>              
              </Carousel.Item>
              <Carousel.Item>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZXyQm_XnGGLZlQI9Ls-2CGYFokzMFINE82KajD5i-IKNeFw/viewform?embedded=true" 
                target='_blank'>
                  <img
                    className="d-block w-100"
                    src={center1}
                    alt="third slide"
                  />   
                </a>            
              </Carousel.Item>
              <Carousel.Item>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZXyQm_XnGGLZlQI9Ls-2CGYFokzMFINE82KajD5i-IKNeFw/viewform?embedded=true" 
                target='_blank'>
                <img
                  className="d-block w-100"
                  src={center2}
                  alt="forth slide"
                />         
                </a>      
              </Carousel.Item>

            </Carousel>
        </div>
        <div className='banner_slider mob_view'>
          <Carousel data-bs-theme="dark" id='carouselExampleAutoplaying'>
              {/* <Carousel.Item>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZXyQm_XnGGLZlQI9Ls-2CGYFokzMFINE82KajD5i-IKNeFw/viewform?embedded=true"
                   target="_blank">
                  <img
                    className="d-block w-100"
                    src={bannerMob1}
                    alt="first slide"
                  />     
                </a>          
              </Carousel.Item> */}
              <Carousel.Item>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZXyQm_XnGGLZlQI9Ls-2CGYFokzMFINE82KajD5i-IKNeFw/viewform?embedded=true" 
                target='_blank'>
                  <img
                    className="d-block w-100"
                    src={bannerMob2}
                    alt="second slide"
                  /> 
                </a>              
              </Carousel.Item>
              <Carousel.Item>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZXyQm_XnGGLZlQI9Ls-2CGYFokzMFINE82KajD5i-IKNeFw/viewform?embedded=true" 
                target='_blank'>
                  <img
                    className="d-block w-100"
                    src={bannerMob3}
                    alt="third slide"
                  />   
                </a>            
              </Carousel.Item>
              <Carousel.Item>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZXyQm_XnGGLZlQI9Ls-2CGYFokzMFINE82KajD5i-IKNeFw/viewform?embedded=true" 
                target='_blank'>
                <img
                  className="d-block w-100"
                  src={bannerMob4}
                  alt="forth slide"
                />         
                </a>      
              </Carousel.Item>
            </Carousel>
        </div>
      </section>      
    </>
  );
};

export default Banner;